import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[appAutoFocusTransition]'
})
export class AutoFocusTransitionDirective { // Only used for date MM/YY fields at the moment.
  // Optionally pass in the next and previous elements from the template.
  @Input() next?: HTMLElement;
  @Input() prev?: HTMLElement;

  constructor(private el: ElementRef<HTMLInputElement>) {}

  // When the input event occurs (e.g. when user types)
  @HostListener('input', ['$event'])
  onInput(event: Event) {
    const input = event.target as HTMLInputElement;
    // Auto-tab to next element if maxLength is reached and a next element is provided
    if (input.value.length === input.maxLength && this.next) {
      this.next.focus();
      // Optionally, move the cursor to the beginning of the next field
      if (this.next instanceof HTMLInputElement) {
        this.next.setSelectionRange(0, 0);
      }
    }
  }

  // Listen for keydown events for navigation
  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    const input = this.el.nativeElement;

    // If the field is not filled, do not allow tab
    if (event.key === 'Tab' && input.value.length != 2) {
      event.preventDefault();
    }

    // If left arrow pressed at beginning and a previous element exists, move focus to it
    if (event.key === 'ArrowLeft' && input.selectionStart === 0 && this.prev) {
      event.preventDefault();
      this.prev.focus();
      if (this.prev instanceof HTMLInputElement) {
        // Set cursor at end of previous input
        const len = this.prev.value.length;
        this.prev.setSelectionRange(len, len);
      }
    }

    // If right arrow pressed at end and a next element exists, move focus to it
    if (event.key === 'ArrowRight' && input.selectionStart === input.value.length && this.next) {
      event.preventDefault();
      this.next.focus();
      if (this.next instanceof HTMLInputElement) {
        // Set cursor at beginning of next input
        this.next.setSelectionRange(0, 0);
      }
    }
  }
}
